import { APP_TRANSACTION, TRANSACTION_HISTORY } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "api/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { NiceSimRegistrationRequestModel } from "./model/NiceSimRegistrationRequestModel";
import { NiceSimRegistrationResponseModel } from "./model/NiceSimRegistrationResponseModel";
import { DataFormat } from "utils/format/DataFormat";
import { isEmpty } from "lodash";

export interface INiceSimRegistrationRepository {
  getList(
    params: NiceSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<NiceSimRegistrationResponseModel>>;
  getDetail(
    params: NiceSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<NiceSimRegistrationResponseModel>>;
  exportReport(
    params: NiceSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>>;
  checkStatus(
    code: string
  ): Promise<BaseApiResponseModel<NiceSimRegistrationResponseModel>>;
}

@injectable()
export class NiceSimRegistrationImpl implements INiceSimRegistrationRepository {
  async getList(
    params: NiceSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<NiceSimRegistrationResponseModel>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    return await client?.get(
      `${TRANSACTION_HISTORY.NICESIMLIST}${
        !isEmpty(queryString) ? `?${queryString}` : ""
      }`,
      params
    );
  }
  async getDetail(
    params: NiceSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<NiceSimRegistrationResponseModel>> {
    return;
  }
  async exportReport(
    params: NiceSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    const queryParams = new URLSearchParams(
      params as unknown as URLSearchParams
    )?.toString();
    const url = `${TRANSACTION_HISTORY.NICESIMLIST}${
      !isEmpty(queryString) ? `?${queryString}` : ""
    }${isEmpty(queryString) ? `?${queryParams}` : `&${queryParams}`}`;
    const token = DataFormat.getToken();
    const alterToken = DataFormat.getAlterToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token ? token : alterToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to export report: ${response.statusText}`);
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
  async checkStatus(
    code: string
  ): Promise<BaseApiResponseModel<NiceSimRegistrationResponseModel>> {
    return await client?.get(APP_TRANSACTION?.CHECK_STATUS, { code });
  }
}
